/** Whether the app route has finished its first project load: the stage renders nothing and the shader warm-ups wait until then, so boot and the first preset never share the main thread or the GPU process with them. */

// A window that never loads a project (none exists, a dock pop-out) still starts.
const CEILING_MS = 15000

let loaded = false
let resolve
const ready = new Promise(r => (resolve = r))

export const isAppLoaded = () => loaded

export const whenAppLoaded = () => ready

/** Marks the app loaded at the next idle moment after the call, so the first preset's React commit lands first. */
export const markAppLoaded = () => {
	if (loaded) return
	const mark = () => {
		if (loaded) return
		loaded = true
		resolve()
	}
	if (typeof requestIdleCallback === 'function') requestIdleCallback(mark, { timeout: 2000 })
	else setTimeout(mark, 0)
}

if (typeof window !== 'undefined') setTimeout(markAppLoaded, CEILING_MS)
